var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141.236,
    height: 39.223,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18.05 51.995h171.319v-64h-171.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pp_logo_svg__logo_pp",
    d: "M20.164 3.895H5.548c-.913 0-1.653.74-1.653 1.654v33.673h1.533V5.557c0-.07.057-.128.128-.128h14.656c4.689 0 8.618 3.723 8.672 8.41.056 4.79-3.704 8.556-8.515 8.556h-8.685v1.534h8.685c5.495 0 9.975-4.405 10.048-9.847.077-5.602-4.65-10.187-10.253-10.187",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pp_logo_svg__logo_pp",
    d: "M20.141 0H3.308A3.308 3.308 0 000 3.308v35.914h1.533V3.325c0-.99.802-1.791 1.791-1.791h16.822c6.924 0 12.732 5.665 12.632 12.59-.096 6.724-5.626 12.165-12.409 12.165h-8.685v1.535h8.685c7.962 0 14.387-6.677 13.92-14.7C33.86 5.713 27.564 0 20.141 0",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pp_logo_svg__logo_pp",
    d: "M20.216 7.79h-11.6a.827.827 0 00-.827.827v30.606h1.534v-29.9H20.23c2.62 0 4.835 2.144 4.758 4.762-.072 2.487-2.075 4.415-4.619 4.415h-8.685v1.534h8.685c3.6 0 6.487-3.072 6.124-6.706-.317-3.173-3.088-5.538-6.277-5.538m37.969-3.895H43.57c-.913 0-1.653.74-1.653 1.654v33.673h1.534V5.557c0-.07.057-.128.127-.128h14.657c4.688 0 8.617 3.723 8.672 8.41.055 4.79-3.705 8.556-8.516 8.556h-8.685v1.534h8.685c5.495 0 9.975-4.405 10.048-9.847.077-5.602-4.65-10.187-10.253-10.187",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pp_logo_svg__logo_pp",
    d: "M58.163 0H41.329a3.308 3.308 0 00-3.308 3.308v35.914h1.533V3.325c0-.99.802-1.791 1.792-1.791h16.82c6.925 0 12.733 5.665 12.633 12.59-.096 6.724-5.625 12.165-12.409 12.165h-8.685v1.535h8.685c7.963 0 14.387-6.677 13.92-14.7C71.88 5.713 65.586 0 58.163 0",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pp_logo_svg__logo_pp",
    d: "M58.237 7.79h-11.6a.827.827 0 00-.826.827v30.606h1.533v-29.9h10.908c2.618 0 4.834 2.144 4.757 4.762-.072 2.487-2.075 4.415-4.619 4.415h-8.685v1.534h8.685c3.6 0 6.487-3.072 6.125-6.706-.318-3.173-3.09-5.538-6.278-5.538",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.586 0h-1.534v33.673c0 .914.741 1.655 1.655 1.655h23.247v-1.534h-23.23a.138.138 0 01-.138-.138z",
    fill: "#f89f43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.691 0h-1.533v35.914a3.309 3.309 0 003.309 3.308h25.488V37.69H81.474a1.782 1.782 0 01-1.783-1.783z",
    fill: "#f89f43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.48 29.899V0h-1.533v30.605c0 .457.37.827.827.827h20.18V29.9zM63.852 35.33h6.022v-1.534h-6.022zm0 3.892h6.022v-1.533h-6.022zM132.917 0h-1.573l-10.24 27.31L110.857 0h-1.638l11.496 30.586c.135.358.64.358.775 0z",
    fill: "#f89f43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.31 34.253L137.136 0h-1.69l-12.58 33.722a.11.11 0 01-.103.071h-3.314a.11.11 0 01-.103-.07L106.7 0h-1.696l12.865 34.255a1.654 1.654 0 001.549 1.073h3.342c.69 0 1.307-.429 1.55-1.075",
    fill: "#f89f43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.655 0l-13.68 36.533a1.78 1.78 0 01-1.667 1.156h-6.527a1.78 1.78 0 01-1.668-1.16L102.528 0h-1.684l13.886 37.074a3.307 3.307 0 003.098 2.148h6.479a3.308 3.308 0 003.099-2.152L141.236 0z",
    fill: "#f89f43"
  }))));
}
export default SvgPpLogo;